import { AlpineComponent } from 'alpinejs';

type TeamTeasersData = {
  init: () => void;
  setupSection: (section: HTMLElement) => void;
  restoreOpacity: (items: HTMLElement[]) => void;
  dimExcept: (items: HTMLElement[], activeEl: HTMLElement) => void;
  findTargetBio: (itemEl: HTMLElement) => HTMLElement | null;
  closeAllBios: (biosInSection: HTMLElement[], items: HTMLElement[]) => void;
  openBio: (section: HTMLElement, items: HTMLElement[], itemEl: HTMLElement, bioEl: HTMLElement) => void;
  closeState: (section: HTMLElement, items: HTMLElement[]) => void;
  attachHoverHandlers: (section: HTMLElement, items: HTMLElement[]) => void;
  attachClickHandlers: (section: HTMLElement, items: HTMLElement[], biosInSection: HTMLElement[]) => void;
}

export default ():AlpineComponent<TeamTeasersData> => ({
  init() {
    const root = this.$el as HTMLElement;
    const sections = Array.from(root.querySelectorAll('.ce-team-teasers-section')) as HTMLElement[];
    
    sections.forEach((section) => this.setupSection(section));
  },

  setupSection(section: HTMLElement) {
    const items = Array.from(section.querySelectorAll('.ce-team-teasers-section-grid-item')) as HTMLElement[];
    const biosInSection = Array.from(section.querySelectorAll('.ce-team-teasers-section-grid-bios')) as HTMLElement[];
    
    this.attachHoverHandlers(section, items);
    this.attachClickHandlers(section, items, biosInSection);
  },

  restoreOpacity(items: HTMLElement[]) {
    items.forEach((i) => { i.style.opacity = '1'; });
  },

  dimExcept(items: HTMLElement[], activeEl: HTMLElement) {
    items.forEach((i) => { i.style.opacity = '.5'; });
    activeEl.style.opacity = '1';
  },

  findTargetBio(itemEl: HTMLElement): HTMLElement | null {
    const grid = itemEl.closest('.ce-team-teasers-section-grid') as HTMLElement | null;
    if (!grid) return null;
    const index = itemEl.getAttribute('data-person-index');
    if (!index) return null;
    const nextSibling = itemEl.nextElementSibling as HTMLElement | null;
    const siblingIsBio = nextSibling?.classList.contains('ce-team-teasers-section-grid-bios');
    return (siblingIsBio
      ? nextSibling
      : (grid.querySelector(`.ce-team-teasers-section-grid-bios[data-person-index="${index}"]`) as HTMLElement | null));
  },

  closeAllBios(biosInSection: HTMLElement[], items: HTMLElement[]) {
    biosInSection.forEach((b) => { b.classList.remove('is-open'); });
    items.forEach((i) => i.classList.remove('active'));
  },

  openBio(section: HTMLElement, items: HTMLElement[], itemEl: HTMLElement, bioEl: HTMLElement) {
    bioEl.classList.add('is-open');
    itemEl.classList.add('active');
    this.dimExcept(items, itemEl);
    section.classList.add('active');
    requestAnimationFrame(() => {
      setTimeout(() => {
        itemEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    });
  },

  closeState(section: HTMLElement, items: HTMLElement[]) {
    this.restoreOpacity(items);
    section.classList.remove('active');
  },

  attachHoverHandlers(section: HTMLElement, items: HTMLElement[]) {
    section.addEventListener('mouseleave', () => this.restoreOpacity(items));
    items.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        items.forEach((i) => { i.style.opacity = '.4'; });
        item.style.opacity = '1';
      });
    });
  },

  attachClickHandlers(section: HTMLElement, items: HTMLElement[], biosInSection: HTMLElement[]) {
    items.forEach((item) => {
      item.addEventListener('click', () => {
        const targetBio = this.findTargetBio(item);
        const isOpen = targetBio ? targetBio.classList.contains('is-open') : false;

        this.closeAllBios(biosInSection, items);

        if (targetBio) {
          if (!isOpen) {
            this.openBio(section, items, item, targetBio);
          } else {
            targetBio.classList.remove('is-open');
            this.closeState(section, items);
          }
        }
      });
    });
  },
});
